export function initOrganicTransformationTabs() {
  const transSections = document.querySelectorAll("[data-trans-section]");

  transSections.forEach((section) => {
    const buttons = section.querySelectorAll(".trans-btn");
    const contents = section.querySelectorAll(".trans-content");

    if (!buttons.length || !contents.length) return;

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-trans");
        if (!target) return;

        buttons.forEach((btn) => {
          btn.classList.remove("bg-[#EF8903]", "text-white", "is-active");
          btn.classList.add("bg-[#FDF0E6]", "text-[#EF8903]");
        });

        button.classList.remove("bg-[#FDF0E6]", "text-[#EF8903]");
        button.classList.add("bg-[#EF8903]", "text-white", "is-active");

        contents.forEach((content) => {
          content.classList.add("hidden");
          content.classList.remove("block");
        });

        const activeContent = section.querySelector(`#${target}`);
        if (activeContent) {
          activeContent.classList.remove("hidden");
          activeContent.classList.add("block");
        }
      });
    });
  });
}